import { getEnv } from "../../../utils/env"

export const getUseSchoolYear = () => {
  // The default is should be "on", and you have to explicitly turn it off
  return getEnv("USE_SCHOOL_YEAR")?.trim().toLowerCase() !== 'false'
}
